import React, {useEffect, useState} from 'react'
import { SSUMenu } from '../SSUMenu'
import { useSelector } from 'react-redux';
import { Badge, Spinner, Table } from 'react-bootstrap';
import ButtonComponent from '../../../components/UI/ButtonComponent/ButtonComponent';
import ModalComponent from '../../../components/UI/Modal/Modal';
import axiosInstance from '../../../api/utils/axiosInstance';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Col, List, Pagination, Popconfirm, Row, Select } from 'antd';
import {TeamOutlined, SearchOutlined} from '@ant-design/icons';
import fillOutTemplate from './EducationViewTemplate';
import "./Organizer.css";
import { EducationSearch } from '../../../components/StrucnaUsavrsavanja/EducationSearch';
import attendanceTemplate from './AttendanceViewTemplate';
import { renderToString } from 'react-dom/server';

const INIT_EDUCATION_RS = { result: [], size: 0 };
const INIT_SEARCH_MODEL = {pageNumber: 1, offset: 50};
const DEFAULT_ERROR_MSG = "Dogodila se greška! Molimo provjerite unosene podatke i pokušajte ponovno.";

const Education = () => {

  const isAdmin = useSelector((state) => {
    let role = state.authentication.userData?.roles[0].roleName
    if(role === "ROLE_SLUZBENIK" || role==="ROLE_REFERENT"){
      return true;
    }
    return false;
  });
  const isOrganizer = useSelector((state) => state.authentication.authority.ORGANIZATOR_EDUKACIJE === "true" ? true : false);
  const subjectOib = useSelector((state) => state.authentication.subjectOib);
  const [currentOrganizer, setCurrentOrganizer] = useState({});
  const [educationResultSet, setEducationResultSet] = useState(INIT_EDUCATION_RS);
  const [searchModel, setSearchModel] = useState(INIT_SEARCH_MODEL);
  const [revizorResultSet, setRevizorResultSet] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try{
        if(isOrganizer){ 
          await fetchEducationsForOrganizerView(subjectOib);
        }else{
          //Trenutno se backend brine o tome je li admin ili obicni korisnik
          await fetchAllEducations();
        }
        await fetchAllRevizors(); 
      }catch(e){
        console.log(e);
      }finally{
        setLoading(false);
      }
    }
    fetchData();
  },[]);

  //DATA FETCHING
  const fetchAllEducations = async () => {
    try{
      const res = await axiosInstance.post("/organizedEducation", searchModel);
      setEducationResultSet(res.data);
    }catch(e){
      let eMsg = e.response?.data || DEFAULT_ERROR_MSG
      toast.error(eMsg,{position:toast.POSITION.BOTTOM_RIGHT});
    }finally{
    }
  }

  const fetchEducationsForOrganizerView = async (organizerOib) => {
    try{
      if(currentOrganizer.id){
        const eduRes = await axiosInstance.post(`/organizedEducation?currentOrganizer=${currentOrganizer.id}`,searchModel);
        setEducationResultSet(eduRes.data) 
      }else{
        const orgRes = await axiosInstance.get(`/organizer/${organizerOib}`);
        const eduRes = await axiosInstance.post(`/organizedEducation?currentOrganizer=${orgRes.data.id}`, searchModel);
        setCurrentOrganizer(orgRes.data);
        setEducationResultSet(eduRes.data);
      }
    }catch(e){
      let eMsg = e.response?.data || DEFAULT_ERROR_MSG;
      toast.error(eMsg, {position: toast.POSITION.BOTTOM_RIGHT});
    }finally{
    }
  
  }

  const fetchAllRevizors = async () => {
    try{
      const res = await axiosInstance.get("/organizedEducation/allActiveRevizors");
      setRevizorResultSet(res.data);
    }catch(e){
      const eMsg = e.response?.data || DEFAULT_ERROR_MSG;
      toast.error(eMsg, {position: toast.POSITION.BOTTOM_RIGHT});
    }finally{
    }
  }

  //SEARCH DATA FETCHING
  const handleOnSearchChanged = (e) => {
    
    if(e instanceof Array){
      //THIS IS for RangePicker onChange case
      setSearchModel({...searchModel, "startDate":(e[0]).format("YYYY-MM-DD"), "endDate": (e[1]).format("YYYY-MM-DD")});
    }else{ 
      const id = (e.target.id);
      let value = (e.target.value);
      
      if(id === "eduActivityAreas"){
        value = e.target.value.replace(" ", ",")
      }

      if(id === "isAreaA"){
        value = e.target.checked;
      }
      
      setSearchModel({...searchModel, [id]: value});
    }
  };

  const handlePageChange = async (pageNumber, pageSize) => {
    const newSearchModel = {...searchModel, pageNumber, offset:pageSize}
    setSearchModel(newSearchModel);
    setLoading(true);
    try{
      if(isOrganizer){
        const eduRes = await axiosInstance.post(`/organizedEducation?currentOrganizer=${currentOrganizer.id}`, newSearchModel);
        setEducationResultSet(eduRes.data);
      }else{
        const res = await axiosInstance.post("/organizedEducation", newSearchModel);
        setEducationResultSet(res.data);
      }
    }catch(e){
      console.log(e);
    }finally{
      setLoading(false);
    }
  };

  const handleOnSearchSubmitted = () => {
    if(isOrganizer){ 
      fetchEducationsForOrganizerView(subjectOib);
    }else{
      //Trenutno se backend brine o tome je li admin ili obicni korisnik
      fetchAllEducations();
    }
  };

  const handleClearFilters = async (e) => {
    setSearchModel(INIT_SEARCH_MODEL);
    setLoading(true);
    try{
      if(isOrganizer){
        const eduRes = await axiosInstance.post(`/organizedEducation?currentOrganizer=${currentOrganizer.id}`,INIT_SEARCH_MODEL);
        setEducationResultSet(eduRes.data);
      }else{
        const res = await axiosInstance.post("/organizedEducation", INIT_SEARCH_MODEL);
        setEducationResultSet(res.data);
      }
    }catch(e){
      console.log(e);
    }finally{
      setLoading(false);
    }
  }

  //TODO: ADD CONDITIONS SO ACTIONS DEPEND ON ROLE AND CURRENT ORGANIZER
  //RENDER FUNCTION FOR RESULT SET
  const mapResultSet = () => {
    if (educationResultSet.size > 0) {
      return educationResultSet.result.map((education) => (
        <tr key={education.idEducation}>
          <td>{education.orgName}</td>
          <td>{education.eduName}</td>
          <td colSpan={2}>{moment(education.eduStartDate).format("DD.MM.YYYY")} - {moment(education.eduEndDate).format("DD.MM.YYYY")}</td>
          {(isAdmin || isOrganizer) && <td>{education.isYearPlanApproved ? <Badge pill variant='success'>Odobreno</Badge> : <Badge pill variant='danger'>Neodobreno</Badge>}</td>}
          <td><EducaionDetailsModal currentEducation={education} /></td>
          {(isAdmin || isOrganizer) && 
            <td title="Popis sudionika"> 
              <AddAttendanceModal canEdit={(isOrganizer && education.idOrganizer === currentOrganizer.id && education.isYearPlanApproved)} options={revizorResultSet} setLoading={setLoading} currentEducation={education} fetchAllEducations={fetchEducationsForOrganizerView}/>
            </td>
          }
        </tr>
      ));
    }
    
    return (<tr><td colSpan="100%">Nema podataka</td></tr>);
  };

  return (
    <>
    {isLoading && (<> <div className="spinner-wrapper"></div> <Spinner as="span" animation="border" size="xl" role="status" aria-hidden="true" variant="secondary" /> </>)}

    <EducationSearch 
      userInputHandler={handleOnSearchChanged}
      onSearchSubmit={handleOnSearchSubmitted}
      onClearFilters={handleClearFilters}
      searchModel={searchModel}
      />

    <br/> <br/>
    <SSUMenu/>
    <br/>

    <Table bordered hover responsive>
        <thead><tr>
          <th>Organizator</th>
          <th>Naziv edukacije</th>
          <th colSpan={2}>Datum održavanja</th>
          {(isOrganizer || isAdmin) && <th>Status</th>}
        </tr></thead>
        <tbody>{mapResultSet()}</tbody>
      </Table>

      <div className='pagination-wrapper'>
        <Pagination responsive defaultCurrent={INIT_SEARCH_MODEL.pageNumber} defaultPageSize={INIT_SEARCH_MODEL.offset} showSizeChanger={true} total={educationResultSet.size}
          current={searchModel.pageNumber}
          pageSize={searchModel.offset}
          onChange={handlePageChange}
        />
      </div>
    </>
  )
}

export default Education

const EducaionDetailsModal = ({ currentEducation}) => {

  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  function printPage() {
    const style =  `<style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        table { border-collapse: collapse; width: 100%; }
        th, td { text-align: left; padding: 8px; border-bottom: 1px solid #ddd; }
        th { background-color: #f2f2f2; }
        section { page-break-after: always; break-after: page;}
    </style>`

    let mywindow = window.open('', 'PRINT', 'height=400,width=600');
    mywindow.document.writeln('<html><head><title>' + document.title + '</title>');
    mywindow.document.writeln(style);
    mywindow.document.writeln('</head><body />');
    const temp = fillOutTemplate(currentEducation);
    const html = renderToString(temp)
    mywindow.document.writeln(html);
    mywindow.document.writeln('</body></html>');
    
    mywindow.document.close();
    mywindow.focus();

    setTimeout(() => {
      mywindow.print();
      mywindow.close();
    }, 2000);
  }

  return (
    <>
      <ButtonComponent type="button" onClick={handleOpenModal} icon={<SearchOutlined/>} size="large"/>
      <ModalComponent show={isModalVisible} onHide={handleCloseModal} size="xl" title={<Button onClick={printPage}>Preuzmi</Button>}>
       
        {fillOutTemplate(currentEducation)}
      </ModalComponent>
    </>
  );
}

const AddAttendanceModal = ({canEdit , options, setLoading, currentEducation, fetchAllEducations}) => {
  //TODO: add PRINT function

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedAttendees, setSelectedAttendees] = useState([]);
  const [selectedEducators, setSelectedEducators] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try{
        const res = await axiosInstance.get(`/organizedEducation/attendees/${currentEducation.idEducation}`);
        if(res && res.status === 200){
          setSelectedAttendees(res.data.attendeeIds);
          setSelectedEducators(res.data.educatorIds);
        }
      }catch(e){
        console.log(e);
      }finally{
        setLoading(false);
      }
    }

    if(isModalVisible){
      fetch();
    }
  },[currentEducation, isModalVisible]);

  //MODAL CONTROLS
  const handleOpenModal = () => {
    setIsModalVisible(true);
  }

  const handleCloseModal = () => {
    setSelectedAttendees([]);
    setSelectedEducators([]);
    setIsModalVisible(false);
  }

  //SELECT  CONTROLS
  const handleMultipleSelect = (type) => (value) => {
    if(type === 'educator'){
      setSelectedEducators(value);
    }else if (type=== 'attendee'){
      setSelectedAttendees(value)
    }
  }

  const mapOptions = () => {
   const temp = options.filter(option => !(selectedAttendees.includes(option.idOsobe) || selectedEducators.includes(option.idOsobe)));
   return temp.map((option) => {return {label: `${option.ime} ${option.prezime} - ${option.regBroj}`, value:option.idOsobe}});
  }

  const mapSelected = (type) => {
    if(type === "attendees"){
      const temp = options.filter(option => selectedAttendees.includes(option.idOsobe));
      return temp.map((option) => {return {label: `${option.ime} ${option.prezime} - ${option.regBroj}`, value:option.idOsobe}});
    }

    if(type==="educators"){
      const temp = options.filter(option => selectedEducators.includes(option.idOsobe));
      return temp.map((option) => {return {label: `${option.ime} ${option.prezime} - ${option.regBroj}`, value:option.idOsobe}});
    }
  }

  const filterOptions = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  
  //SUBMIT ATTENDANCE CONTROLS

  const handleSubmitAttendance = async () => {
    setLoading(true);
    try{
      const body = {
        "attendeeIds": selectedAttendees,
        "educatorIds": selectedEducators
      }
      const res = await axiosInstance.put(`/organizedEducation/updateAttendees/${currentEducation.idEducation}`, body)
      if(res && res.status){
        toast.success("Popis uspješno spremljen", {position: toast.POSITION.BOTTOM_RIGHT});
      }
    }catch(e){
      const eMsg = e.response?.data || DEFAULT_ERROR_MSG
      toast.error(eMsg, {position: toast.POSITION.BOTTOM_RIGHT});
    }finally{
      await fetchAllEducations();
      handleCloseModal();
      setLoading(false);
    }
  }

  function printAttendance() {
    const style =  `<style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        table { border-collapse: collapse; width: 100%; }
        th, td { text-align: left; padding: 8px; border-bottom: 1px solid #ddd; }
        th { background-color: #f2f2f2; }
        section { page-break-after: always; break-after: page;}
    </style>`

    let mywindow = window.open('', 'PRINT', 'height=400,width=600');
    mywindow.document.writeln('<html><head><title>' + document.title + '</title>');
    mywindow.document.writeln(style);
    mywindow.document.writeln('</head><body />');
    const tempAttendees = mapSelected("attendees");
    const tempEducators = mapSelected("educators");
    const temp = attendanceTemplate(currentEducation,tempAttendees, tempEducators);
    const html = renderToString(temp)
    mywindow.document.writeln(html);
    mywindow.document.writeln('</body></html>');
    
    mywindow.document.close();
    mywindow.focus();

    setTimeout(() => {
      mywindow.print();
      mywindow.close();
    }, 2000);
  }

  return(
    <>
      <ButtonComponent title="Dodaj" type="button" onClick={handleOpenModal} icon={<TeamOutlined/>} size="large"/>
      <ModalComponent show={isModalVisible} onHide={handleCloseModal} size="xl" title="Sudionici edukacije" backdrop="static" keyboard={false}>
        {canEdit && 
          <div className='edu-select-attendees-wrapper'>
            <div>
              <Select mode="multiple" allowClear placeholder="Odaberite edukatore" className="edu-select"
                  onChange={handleMultipleSelect("educator")} options={mapOptions()} filterOption={filterOptions} value={mapSelected("educators")}
                  />
              <Select mode="multiple" allowClear placeholder="Odaberite sudionike" className="edu-select"
                  onChange={handleMultipleSelect("attendee")} options={mapOptions()}  filterOption={filterOptions} value={mapSelected("attendees")}
                  />
            </div>
              <Popconfirm title={`Želite spremiti ${selectedAttendees.length + selectedEducators.length} sudionika?`} onConfirm={handleSubmitAttendance} placement='bottom' overlayClassName='edu-popconfirm'>
                <ButtonComponent >Spremi polaznike</ButtonComponent>
              </Popconfirm>
          </div>
        }
        <div style={{justifySelf:"end"}}>
          <Button onClick={printAttendance}>Ispis sudionika</Button>
        </div>
        <Row>
          <Col span={12}>
            <List
              header="Edukatori" 
              dataSource={mapSelected("educators")}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta description={item.label}/>
                </List.Item>
              )}
            />
          </Col>
          <Col span={12}>
            <List 
              header="Polaznici"
              dataSource={mapSelected("attendees")}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta description={item.label}/>
                </List.Item>
              )}/>
          </Col>
        </Row>

      </ModalComponent>
    </>
  )
}